import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const buttonVariants = cva(
  "btn-emil inline-flex items-center justify-center whitespace-nowrap rounded-full text-sm font-medium ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 backdrop-blur-md",
  {
    variants: {
      variant: {
        default: "bg-primary/20 text-primary-foreground border border-primary/30 hover:bg-primary/30 hover:border-primary/50",
        destructive:
          "bg-destructive/20 text-destructive-foreground border border-destructive/30 hover:bg-destructive/30 hover:border-destructive/50",
        outline:
          "border border-foreground/20 bg-background/20 hover:bg-foreground/10 hover:border-foreground/30",
        secondary:
          "bg-secondary/20 text-secondary-foreground border border-secondary/30 hover:bg-secondary/30 hover:border-secondary/50",
        ghost: "bg-transparent hover:bg-foreground/10 border border-transparent hover:border-foreground/20",
        link: "text-primary underline-offset-4 hover:underline bg-transparent border-none backdrop-blur-none",
      },
      size: {
        default: "h-10 px-4 py-2",
        sm: "h-9 rounded-md px-3",
        lg: "h-11 rounded-md px-8",
        icon: "h-10 w-10",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  return (
    (<Comp
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props} />)
  );
})
Button.displayName = "Button"

export { Button, buttonVariants }
